import Icon from "core/ui-kit/icon"

export const columns = [
    {
        title: "backoffice.affiliates.id",
        dataIndex: "longId",
        mobileLevel: 1,
        copy: true
    },

    {
        title: "backoffice.affiliates.userName",
        dataIndex: "name",
        mobileLevel: 2
    }
]

export const failedModalcolumns = [
    {
        title: "backoffice.affiliates.id",
        dataIndex: "longId",
        mobileLevel: 1,
        render: value => (
            <div className="rt--flex rt--align-center">
                <Icon name="cancel" size={18} color = "var(--error-color)" />
                <span className="rt--title rt--pl-4">{value}</span>
            </div>
        )
    },

    {
        title: "backoffice.affiliates.userName",
        dataIndex: "userName",
        mobileLevel: 2
    }
]